/* eslint-disable react-hooks/exhaustive-deps */
import PageRoutes from './PageRoutes';

export function App() {
  return <PageRoutes />;
}

export default App;
